import React from 'react';
import './Testimonials.css';

import 'swiper/swiper.scss';
function TestimonialItem(props) {
  return (
    <div className="testimonial" key={props.testimonial.name}>
      <span
        className="fa fa-quote-left fa-3x "
        style={{ color: '#96D6FC' }}
      ></span>

      <p className="testimonial-quote" style={{ paddingRight: '20px' }}>
        {props.testimonial.text}
      </p>
      <div className="testimonial-content">
        <div className="testimonial_pic">
          <img
            src={props.testimonial.imageUrl}
            alt=""
            className="testimonial_dummy"
          />
        </div>
        <h3 className="title">{props.testimonial.name}</h3>
        <h3 className="post">{props.testimonial.designation}</h3>
      </div>
    </div>
  );
}

export default TestimonialItem;
